import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import swal2 from "sweetalert2";

declare var jQuery: any;

@Component({
    selector: 'navigation',
    templateUrl: 'navigation.component.html'
})


export class NavigationComponent implements OnInit {
    userName;
    version;
    baseUrl;

    constructor(private router: Router) { }
    // tslint:disable-next-line:use-life-cycle-interface
    ngAfterViewInit() {
        jQuery('#side-menu').metisMenu();
    }

    ngOnInit() {
        this.baseUrl = environment.baseUrl
        this.version = environment.version
        this.userName = localStorage.getItem("user");
    }

    activeRoute(routename: string): boolean {
        return this.router.url.indexOf(routename) > -1;
    }

    open() {
        jQuery('#sidebarCollapse').on('click', function () {
            jQuery('#sidebar').toggleClass('active');
        });
    }

    chiamaLocatelli(){
        swal2({
            title: "Contatti",
            type: "info",
            html: "Mail: comunicazione@orioshuttle.com<br>Sito internet: <a href='www.autoservizilocatelli.it' target='_blank'>www.autoservizilocatelli.it</a>"
          });
    }
}



// WEBPACK FOOTER //
// ./src/app/common/navigation/navigation.component.ts